<!--
 * @Author: hfxie
 * @Date: 2021-01-01 14:52:54
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-11-13 15:26:32
 * @Description: 甘特图左侧结构树WBS
-->

<template>
  <!-- 纯文字行 -->
  <div
    v-if="item.rowType == '2'"
    class="task-info-row task-info-row-txt"
    :class="{
      'task-info-row-isSelect': selectedShow,
    }"
    :style="{
      'padding-left': (item.level * 20 < $store.state.treeWidth - 20)? item.level * 20 + 36 + 'px': $store.state.treeWidth - 20 + 36 + 'px',
      'line-height': estimatedItemSize + 'px',
      'font-size': $store.getters.treeFontSize + 'px',
      'font-weight': $store.getters.treeFontWeight,
    }"
    :data-rowtype="item.rowType"
    @click="SelectedRowOne(item)"
  >
    {{ item.name }}
  </div>

  <!-- 标准功能行 -->
  <div
    v-else
    class="task-info-row"
    :key="item.id"
    :class="{
      'act': $store.state.selectTaskIndex == indRow,
      'task-info-row-isSelect': selectedShow,
    }"
    @click="SelectedRowOne(item)"
    @contextmenu.prevent.stop="ContextmenuHandle($event,item)"
  >
    <!-- 特殊单元格:树结构 -->
    <div
      v-if="!$store.state.noTree"
      class="task-info-item task-info-title"
      :class="{
        'info-title-group': !item.isSealf,
        'task-info-item-border-right': item.borderRight == true,
      }"
      :style="{
        'width': $store.state.treeWidth - 1 + 'px',
        'padding-left': (item.level * 20 < $store.state.treeWidth - 20)? item.level * 20 + 'px': $store.state.treeWidth - 20 + 'px'
      }"
      :title="item.name"
    >
      <div class="tree-main">
        <!-- 折叠态 -->
        <i
          v-if="!item.isSealf && !item.isExpand"
          :style="{'color': $store.state.theme}"
          class="el-icon-caret-right select-icon"
          @click.stop="ChangeExpand(item)"
        ></i>
        <i
          v-else-if="!item.isSealf && item.isExpand"
          :style="{'color': $store.state.theme}"
          class="el-icon-caret-bottom select-icon"
          @click.stop="ChangeExpand(item)"
        ></i>
        <i
          v-else-if="item.isSealf"
          class="el-icon-location select-icon task-info-label"
          @click.stop="LocationTask(item)"
        ></i>

        <!-- 选中态 -->
        <div
          class="task-info-select"
          ref="rowSelectRef"
          v-show="isRowCheckBoxShow"
          :style="{
            'height': estimatedItemSize + 'px',
            'line-height': estimatedItemSize + 'px',
          }"
          @click.stop="SelectedCol(item, indRow)"
        >
          <div
            v-if="ganttType === CONSTNAME.TODOS"
            class="task-info-select-status task-info-select-status-disable"
          ></div>
          <div
            v-else-if="selectedShow"
            class="task-info-select-status task-info-select-status-check"
          >
            <Icon class="el-icon-check"></Icon>
          </div>
          <div v-else class="task-info-select-status"></div>
        </div>

        <!-- 行图标 额外加了3个 可以自定义颜色，不传值默认使用内置颜色 并增加链接形式 -->
        <i
          v-show="isRowIconShow&&String(item.entityFlagIndex)"
          class="tree-icon"
          :style="{'color': item.entityFlagColor? item.entityFlagColor : $store.state.theme}"
          :class="iconList[item.entityFlagIndex]"
        ></i>
          <i
          v-show="isRowIconShow&&String(item.entityFlagIndex1)"
          class="tree-icon"
          :style="{'color': item.entityFlagColor1? item.entityFlagColor1 : $store.state.theme}"
          :class="iconList[item.entityFlagIndex1]"
        ></i>
          <i
          v-show="isRowIconShow&&String(item.entityFlagIndex2)"
          class="tree-icon"
          :style="{'color': item.entityFlagColor2? item.entityFlagColor2 : $store.state.theme}"
          :class="iconList[item.entityFlagIndex2]"
        ></i>
          <i
          v-show="isRowIconShow&&String(item.entityFlagIndex3)"
          class="tree-icon"
          :style="{'color': item.entityFlagColor3? item.entityFlagColor3 : $store.state.theme}"
          :class="iconList[item.entityFlagIndex3]"
        ></i>
          <img
          v-if="String(item.entityFlagSrc)"
          :style="{width:item.entityFlagSrc?'16px':0,height:item.entityFlagSrc?'16px':0,verticalAlign:'middle'}"
          :src="item.entityFlagSrc"
        />
            <img
          v-if="String(item.entityFlagSrc1)"
          :style="{width:item.entityFlagSrc1?'16px':0,height:item.entityFlagSrc1?'16px':0,verticalAlign:'middle'}"
          :src="item.entityFlagSrc1"
        />
        <img
          v-if="String(item.entityFlagSrc2)"
          :style="{width:item.entityFlagSrc2?'16px':0,height:item.entityFlagSrc2?'16px':0,verticalAlign:'middle'}"
          :src="item.entityFlagSrc2"
        />
          <img
          v-if="String(item.entityFlagSrc3)"
          :style="{width:item.entityFlagSrc3?'16px':0,height:item.entityFlagSrc3?'16px':0,verticalAlign:'middle'}"
          :src="item.entityFlagSrc3"
        />
        <!-- 节点名 -->
        <span
          class="tree-name"
          :style="{
            'height': estimatedItemSize + 'px',
            'line-height': estimatedItemSize + 'px',
            'font-size': $store.getters.treeFontSize + 'px',
            'font-weight': $store.getters.treeFontWeight,
          }"
        >{{ item.name }}</span>

      </div>
      <!-- 编辑按钮 -->
      <i
        v-if="getAuthentication && item.editable"
        title="编辑"
        class="el-icon-edit-outline btn-edit"
        :style="{
          'color': $store.state.theme,
          'line-height': estimatedItemSize + 'px',
        }"
        @click.stop="Edit($event, item)"
      ></i>

    </div>
    <!-- wbs单元格 -->
    <template v-if="colsShow.length > 0">
      <template v-for="(col2, colIndex2) in item.cellList">
        <template v-if="typeof colsShow[colIndex2] == 'object'">
          <!-- 默认 -->
          <div
            :key="col2.val + Date.now() + colIndex2"
            class="task-info-item task-info-cell"
            :class="{
              'task-info-item-border-right': item.borderRight == true,
            }"
            :title='col2.val'
            :style="{
              'width': colsShow[colIndex2].colWidth + 'px',
              'font-size': colsShow[colIndex2].fontSize + 'px',
              'text-align': colsShow[colIndex2].colAlign,
              'line-height': estimatedItemSize + 'px',
            }"
          >
          <i
          v-show="!col2.val&&String(col2.wbsTableIconIndex)"
          class="tree-icon"
          :style="{'color': col2.wbsTableIconColor? col2.wbsTableIconColor : $store.state.theme, 'font-size':'15px'} "
          :class="iconList[col2.wbsTableIconIndex]"
        ></i>
        <img
          v-if="String(col2.wbsTableIconSrc)"
          :style="{width:col2.wbsTableIconSrc?'16px':0,height:col2.wbsTableIconSrc?'16px':0,}"
          :src="col2.wbsTableIconSrc"
        />
            {{ col2.val ?col2.val :'' }}
          </div>
        </template>
      </template>
    </template>

  </div>

</template>

<script>

const colorArr = [];
import CONSTNAME from "@/ConstName.js";
export default {
  name: "FormBodyCol",
  data() {
    return {
      iconList: CONSTNAME.ICON_LIST,

      /* 虚拟列表 */
      screenHeight: 0, // 可视区域高度
      startOffset: 0, // 偏移量
      start: 0, // 起始索引
      end: 0, // 结束索引
      scrollTop: 0,
      positions: null,
      /* 定位 */
      preLocationItem: null,
      selectedShow: false,

    };
  },
  inject: ["CONSTNAME"],
  props: {
    colsShow: {
      type: Array,
      default: () => { return []; },
    },
    rowsShow: {
      type: Array,
      default: () => { return []; },
    },
    rowsShowMap: {
      type: Object,
      default: () => { return null; },
    },
    item: {
      type: Object,
      default: null,
    },
    ganttType: {
      type: String,
      default: "pageData",
    },
    estimatedItemSize: {
      type: Number,
      default: () => { return 50; },
    },
    selectedArr: {
      type: Array,
      default: () => { return []; },
    },
  },
  computed: {
    getAuthentication() {
      return this.$utils.getAuthentication(this.$store.state.accessLevel, [1]);
    },
    indRow() {
      return this.rowsShowMap && this.rowsShowMap[this.item.id] ? this.rowsShowMap[this.item.id].realRow : -1;
    },
    // 表单行是否显示勾选框
    isRowCheckBoxShow() {
      const _isRowCheckBoxShow = this.$store.state.viewSchem.isRowCheckBoxShow == true;
      return _isRowCheckBoxShow;
    },
    // 表单行是否显示名称前置图标
    isRowIconShow() {
      const _isRowIconShow = this.$store.state.viewSchem.isRowIconShow == true;
      return _isRowIconShow;
    },
  },
  watch: {
    selectedArr: {
      handler(newVal = [], oldVal) {
        if (newVal.includes(this.item.id)) {
          this.selectedShow = true;
        } else {
          this.selectedShow = false;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 选中状态修改
    SelectedCol(item) {
      if (this.ganttType != this.CONSTNAME.TODOS) {
        // console.log("复选框点击");
        const oldStatus = this.selectedShow;
        this.$store.commit("set_selectStatus_item", { ganttType: this.ganttType, id: item.id, status: !oldStatus });
        this.$store.dispatch("_selectNodeGtTreeList", item);
      }
    },
    // 点击单选行-除复选框之外的(重置选中集合为当前行)
    SelectedRowOne(item) {
      return this.SelectedCol(item);
      if (this.ganttType != this.CONSTNAME.TODOS) {
        // console.log("单选");
        this.$store.commit("set_selectStatus_area", {
          ganttType: this.ganttType,
          selectedArr: [item.id],
        });
        this.$store.dispatch("_selectNodeGtTreeListOne", item);
      }
    },
    // 展开状态修改
    ChangeExpand(item) {
      this.$store.dispatch("_expandNodeGttreelist", item);
    },
    LocationTask(item) {
      if (item != this.preLocationItem) {
        this.preLocationItem = item;
        this.$store.dispatch("getLocation", item);
      }
    },
    // 随机颜色值
    randomColor(_index) {
      if (colorArr[_index]) {
        return colorArr[_index];
      }
      const arr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
      let str = "#";
      for (let i = 1; i <= 6; i++) {
        const index = Math.floor(Math.random() * 16);
        str += arr[index];
      }
      colorArr[_index] = str;
      return str;
    },
    // trafficLight(index){
    //   if(index == 17){
    //       return{
    //      color: 'green'
    //    }
    //   }else if(index == 18){
    //        return{
    //      color: 'yellow'}
    //   }else if(index == 19) {
    //      return{
    //      color: 'red'}
    //   }
    // },
    // 格式化右键菜单配置
    formatMenus(item, menuArr) {
      const _menus = [];
      if (menuArr instanceof Array && menuArr.length > 0) {
        const _self = this;
        for (let index = 0; index < menuArr.length; index++) {
          const element = menuArr[index];
          element.label = element.cbName;
          if (element.children instanceof Array && element.children.length > 0) {
            this.formatMenus(item, element.children);
          } else {
            element.onClick = () => {
              _self.$store._invoke(element.cbNumber, item);
            };
            delete element.children;
          }
          _menus.push(element);
        }
      }
      return _menus;
    },
    // 右键菜单
    ContextmenuHandle(event, item) {
      const _self = this;
      const _menus = item.menus;
      _menus instanceof Array &&
      _menus.length > 0 &&
      (() => {
        const items = _self.formatMenus(item, _menus);
        if (items.length > 0) {
          _self.$contextmenu({
            items,
            event,
            customClass: "form-custom-class-hfx",
            zIndex: 5000,
            minWidth: 110,
          });
        }

      })();
    },
    Edit(e, col) {
      this.$store.dispatch("_editRow", col);
    },

  },
};
</script>

<style scoped lang='less'>
@import './FormBody.less';
</style>
